import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { Text } from "../text/text";
import { CSS_CLASSES } from "./avatar-css-classes";

export interface AvatarProps {
  /**
   * First name to be used for the initials within the avatar.
   */
  firstName: string;

  /**
   * Last name to be used for the initials within the avatar.
   */
  lastName: string;

  /**
   * Avatar size
   *
   * @default medium
   */
  size?: "small" | "medium" | "large";

  /**
   * Visual variant. Should be coordinated with active background color of parent element.
   */
  variant: "dark" | "light";

  /**
   * Color option for the `light` variant. Ignored if variant is `dark`.
   */
  color?: "interactive" | "primary";

  /**
   * Apply/override styling by passing in custom CSS class-name(s) using this prop.
   */
  className?: string;
}

export const Avatar: FunctionComponent<AvatarProps> = ({
  firstName = "",
  lastName = "",
  size = "medium",
  variant = "light",
  color = "interactive",
  className,
  ...restProps
}) => {
  return (
    <div
      className={classNames(
        CSS_CLASSES.AVATAR_ROOT,
        {
          [CSS_CLASSES.AVATAR_SIZE_LARGE]: size === "large",
          [CSS_CLASSES.AVATAR_SIZE_SMALL]: size === "small",
          [CSS_CLASSES.AVATAR_COLOR_INTERACTIVE]: color === "interactive",
          [CSS_CLASSES.AVATAR_COLOR_PRIMARY]: color === "primary",
          [CSS_CLASSES.AVATAR_VARIANT_DARK]: variant === "dark",
          [CSS_CLASSES.AVATAR_VARIANT_LIGHT]: variant === "light",
        },
        className
      )}
      {...restProps}
    >
      <Text color={variant === "light" ? color : "white"} className={CSS_CLASSES.AVATAR_INITIALS}>
        {firstName[0]?.toUpperCase()}
        {lastName[0]?.toUpperCase()}
      </Text>
    </div>
  );
};
